export const root = '/email';

const paths = {
  root,
  list: '/email/:module',
  detail: '/email/:module/:id',
  userModule: '/email/user-:module/:id',
};

export default paths;
